<div class="d-flex align-items-center text-white" >
  <i class="iconify mr-2" [attr.data-icon]="iconName" data-inline="true"></i>
  <span>{{args.message}}</span>
</div>
